export { default as alerts } from './alerts.json';
export { default as common } from './common.json';
export { default as components } from './components.json';
export { default as layout } from './layout.json';
export { default as login } from './login.json';
export { default as navigation } from './navigation.json';
export { default as diagnostics } from './diagnostics.json';
export { default as overview } from './overview.json';
export { default as performance } from './performance.json';
export { default as settings } from './settings.json';
export { default as configuration } from './configuration.json';
export { default as not_found } from './not_found.json';
export { default as error } from './error.json';
export { default as logs } from './logs.json';
export { default as companies } from './companies.json';
// NOTE: API considers the logs page as 'log' for filters, so exporting it as `log` for simplicity's sake
export { default as log } from './logs.json';
export { default as company } from './company.json';
export { default as sites } from './sites.json';
export { default as welcome_dialog } from './welcome_dialog.json';
export { default as admin } from './admin.json';
export { default as mfa } from './mfa.json';
